module.exports = __webpack_public_path__ + "img/back-icon03.0e93274d.png";